// Localização: frontend/src/components/Agendamentos/AgendamentoTipoFilter.jsx
// Componente de Filtro de Tipo de Agendamento com Dropdown

import React from 'react';
import { Tag, Check, X, Briefcase, Stethoscope, Home, Syringe } from 'lucide-react';

/**
 * @component AgendamentoTipoFilter
 * @description Componente de filtro de tipo de agendamento com dropdown
 * @param {Array} tipos - Array de tipos selecionados
 * @param {function} onTiposChange - Callback quando tipos mudam
 * @param {function} onClose - Callback para fechar o filtro (opcional)
 * @param {string} className - Classes CSS adicionais
 */
const AgendamentoTipoFilter = ({
    tipos = [],
    onTiposChange,
    onClose = null,
    className = ''
}) => {
    // Opções de tipo de agendamento com ícones
    const tipoOptions = [
        { value: 'Plantão', label: 'Plantão', icon: Briefcase, bgColor: 'bg-blue-50', activeBgColor: 'bg-blue-100', color: 'text-blue-600', hoverColor: 'hover:bg-blue-100' },
        { value: 'Consulta', label: 'Consulta', icon: Stethoscope, bgColor: 'bg-emerald-50', activeBgColor: 'bg-emerald-100', color: 'text-emerald-600', hoverColor: 'hover:bg-emerald-100' },
        { value: 'Visita', label: 'Visita', icon: Home, bgColor: 'bg-purple-50', activeBgColor: 'bg-purple-100', color: 'text-purple-600', hoverColor: 'hover:bg-purple-100' },
        { value: 'Procedimento', label: 'Procedimento', icon: Syringe, bgColor: 'bg-orange-50', activeBgColor: 'bg-orange-100', color: 'text-orange-600', hoverColor: 'hover:bg-orange-100' }
    ];

    const handleTipoToggle = (tipoValue) => {
        if (!onTiposChange) return;
        
        const currentTipos = tipos || [];
        let newTipos;
        if (currentTipos.includes(tipoValue)) {
            newTipos = currentTipos.filter(t => t !== tipoValue);
        } else {
            newTipos = [...currentTipos, tipoValue];
        }
        onTiposChange(newTipos);
    };

    return (
        <div className={`bg-white rounded-xl shadow-2xl border border-gray-200 py-2 relative ${className}`}>
            {/* Botão de Fechar */}
            {onClose && (
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 p-1.5 rounded-lg hover:bg-gray-100 transition-colors text-gray-400 hover:text-gray-600 z-10"
                    title="Fechar filtro"
                    aria-label="Fechar filtro"
                >
                    <X className="h-4 w-4" />
                </button>
            )}

            {/* Header */}
            <div className="px-4 py-2 border-b border-gray-200">
                <h3 className="text-sm font-semibold text-gray-900 flex items-center gap-2">
                    <Tag className="h-4 w-4 text-emerald-600" />
                    Tipo de Agendamento
                </h3>
            </div>

            {/* Conteúdo do dropdown */}
            <div className="pt-1 max-h-[400px] overflow-y-auto">
                {tipoOptions.map(option => {
                    const isSelected = tipos?.includes(option.value);
                    const Icon = option.icon;
                    
                    return (
                        <button
                            key={option.value}
                            onClick={() => handleTipoToggle(option.value)}
                            className={`
                                w-full flex items-center gap-3 px-4 py-2.5
                                transition-colors text-left
                                ${isSelected ? option.activeBgColor : 'hover:bg-gray-50'}
                            `}
                        >
                            <div className={`
                                flex items-center justify-center w-5 h-5 rounded border-2 transition-colors
                                ${isSelected 
                                    ? 'bg-emerald-600 border-emerald-600' 
                                    : 'border-gray-300 bg-white'
                                }
                            `}>
                                {isSelected && (
                                    <Check className="h-3 w-3 text-white" />
                                )}
                            </div>
                            <Icon className={`h-4 w-4 ${isSelected ? option.color : 'text-gray-500'}`} />
                            <span className={`text-sm font-medium ${isSelected ? option.color : 'text-gray-700'}`}>
                                {option.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default AgendamentoTipoFilter;

